export const processImagesHelper = async imageFiles => {
    const compressedImages = await Promise.all(
        imageFiles.map(async file => {
            const compressedBlob = await compressImage(file)
            const base64Data = await blobToBase64(compressedBlob)

            return {
                name: file.name,
                type: file.type,
                data: base64Data,
            }
        }),
    )

    return compressedImages
}

const compressImage = file => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = event => {
            const img = new Image()
            img.src = event.target.result

            img.onload = () => {
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                const MAX_WIDTH = 800
                const scale = MAX_WIDTH / img.width
                canvas.width = MAX_WIDTH
                canvas.height = img.height * scale

                ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

                canvas.toBlob(
                    blob => {
                        if (blob) {
                            resolve(blob)
                        } else {
                            reject(new Error('Blob creation failed'))
                        }
                    },
                    'image/jpeg',
                    0.7,
                )
            }

            img.onerror = () => reject(new Error('Image failed to load'))
        }

        reader.onerror = () => reject(new Error('FileReader failed'))
        reader.readAsDataURL(file)
    })
}

const blobToBase64 = blob => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = error => reject(error)
        reader.readAsDataURL(blob)
    })
}

export function base64ToFile(base64, filename) {
    const arr = base64.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], filename, { type: mime })
}
